import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UtilitiesService } from '../../services/utilities.service';
import { CognitoServiceService } from '../../services/cognito-service.service';
import { FormDefinitionsService } from '../../services/forms/form-definitions.service';
import { CommonService } from 'src/app/services/common/common.service';
import { PopupConsentPinComponent } from '../popups/popup-consent-pin/popup-consent-pin.component';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-vua-creation',
  templateUrl: './vua-creation.component.html',
  styleUrls: ['./vua-creation.component.scss']
})
export class VuaCreationComponent implements OnInit {

  vuaCreationForm: any;
  signupData: any;
  userInputData: { name: any; username: any; email: any; phone_number: any; password: any; consentPin: any; confirmation: any;};
  vrificationPopupData: DynamicItem;
  showVerificationPopupFlag: boolean;

  constructor(
    private router: Router,
    private util: UtilitiesService,
    private cognito: CognitoServiceService,
    private formDefinitionsService: FormDefinitionsService,
    private commonService: CommonService,
    private http: HttpService
  ) { }

  ngOnInit() {
    this.vuaCreationForm = this.formDefinitionsService.vuaCreationForm
  }

  /**
   * @desc To signup a user
   * @param  {object} form
   */
  doSignup(event) {
    let form = event.formData;
    let signupData = JSON.parse(localStorage.getItem("signUpDetails"));
    if(!signupData) {
      this.showGlobalPopup("Invalid Details");
    }
    if (form.valid) {
      this.userInputData = {
        name: signupData.name,
        username: form.controls.vua.value,
        email: signupData.email,
        phone_number: signupData.phone_number,
        password: form.controls.password.value,
        consentPin: form.controls.consentPin.value,
        confirmation: form.controls.consentPin.accept_terms
      };
      this.cognito.doSignup(this.userInputData, (signUpData) => {
        form.reset();
        this.signupData = signUpData;
        this.storeUserInDb().subscribe((res)=> {
          this.showPopup();
        });
      });
    }
  }

  showPopup() {
    let popuptext: any = {
      body: "Please Enter confirmation Code sent to mobile to Confirm",
      heading: "Account Confirmation"
    }

    popuptext.successCallback = this.verificationConfirm.bind(this);
    popuptext.cancelCallback = this.closePopup.bind(this);

    this.vrificationPopupData = new DynamicItem(PopupConsentPinComponent, popuptext);
    this.showVerificationPopupFlag = true;
  }

  verificationConfirm(pin) {
    this.cognito.verify({ userName: this.signupData.user.username }, pin, () => {
        this.closePopup();
        this.router.navigate(['/login']);
    });
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    this.showVerificationPopupFlag = false;
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }

    this.commonService.showGlobalMessage(popuptext);
  }
  
  storeUserInDb() {
    var obj = {
      userId: this.signupData.userSub,
      firstName: this.userInputData.name,
      middleName: '',
      lastName: '',
      vua: this.userInputData.username + this.commonService.vuaExtension,
      consentPin: this.userInputData.consentPin,
      type: 'signupdata'
    }

    let options = {
      type: 'post',
      url: 'userInfo',
      data: obj
    };
    return this.http.makeHttpRequest(options);
  }

}
